import React from "react";
import { StyledFileRow } from "./StyleComponents";
import { EditFormElement } from "@kaltura/mediaspace-shared-edit-entry";
import { KalturaExternalMediaEntry } from "kaltura-typescript-client/api/types/KalturaExternalMediaEntry";
import { KalturaMediaEntry } from "kaltura-typescript-client/api/types/KalturaMediaEntry";
import { UploadStatus, MediaUploadFileInfo } from "@kaltura/mediaspace-shared-upload";

interface YouTubeEditFormProps {
    youtubeEntry: KalturaExternalMediaEntry;
    fieldsStructure: EditFormElement[];
    editRowKey: number;
    onCancel: () => void;
    onEdit: () => void;
    onBeforeSubmit?: (entryIds: string[], data: any) => Promise<{ confirm: boolean; isEditable: boolean }>;
    onSubmit: (data: any) => void;
    onSubmitStarted: () => void;
    onRemove: () => void;
    onClose: () => void;
    publishEnabled?: boolean;
    formId: string;
    showEditFormButtons?: boolean;
    onCanSaveForm: (canSave: boolean) => void;
    onReadyForPublish?: (entryIds: string[], readyForPublish: boolean) => void;
    singleUpload?: boolean;
    showMediaLink?: boolean;
}

/*
 * YouTubeEditContent is a reusable component that renders the content for editing metadata of a YouTube-imported entry.
 * It displays the entry's information and allows users to update fields as defined by the provided structure.
 * The component is stateless and receives all data, callbacks, and configuration via props, making it suitable for use in different contexts.
 */
const YouTubeEditForm: React.FC<YouTubeEditFormProps> = ({
    youtubeEntry,
    fieldsStructure,
    editRowKey,
    onCancel,
    onEdit,
    onBeforeSubmit,
    onSubmit,
    onSubmitStarted,
    onRemove,
    onClose,
    onReadyForPublish,
    publishEnabled = true,
    formId,
    showEditFormButtons = false,
    onCanSaveForm,
    singleUpload = true,
    showMediaLink = true,
}) => {
    const fileInfoObj = {
        entry: youtubeEntry as KalturaMediaEntry,
        entryMetadata: {},
        fileMetaData: {
            progress: 100,
            status: UploadStatus.READY,
            tokenId: "",
        },
    } as MediaUploadFileInfo;

    return (
        <>
            <StyledFileRow
                fileInfo={fileInfoObj}
                isOpen={!!fileInfoObj.entry}
                shouldClose={false}
                editForm={fieldsStructure}
                onCancel={onCancel}
                onEdit={onEdit}
                onBeforeSubmit={onBeforeSubmit}
                onSubmit={onSubmit}
                onSubmitStarted={onSubmitStarted}
                onRemove={onRemove}
                onClose={onClose}
                key={editRowKey}
                publishEnabled={publishEnabled}
                formId={formId}
                showEditFormButtons={showEditFormButtons}
                onCanSaveForm={onCanSaveForm}
                onReadyForPublish={onReadyForPublish}
                singleUpload={singleUpload}
                showMediaLink={showMediaLink}
            />
        </>
    );
};

export default YouTubeEditForm;
